import MUISwitch from "@mui/material/Switch";

const Switch = MUISwitch;

export default Switch;
